import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row } from 'react-bootstrap';
import * as actionCreator from '../../actions/';
import { useNavigate } from 'react-router';
import MainLayout from '../../layouts/MainLayout';
import CheckmarkCircle from 'react-ionicons/lib/CheckmarkCircle';
import EllipseOutline from 'react-ionicons/lib/EllipseOutline';
import { connect } from 'react-redux';
import { WaitFor } from '../../helpers/Utils';
import Overlay from '../../components/Overlay/Overlay';
import languageManager from '../../helpers/Language';
import BlockTitle from '../../components/BlockTitle/BlockTitle';
import UserAnalytic from '../../helpers/UserAnalytic';
import UserInformation from '../../components/Forms/UserInformation';
import UpdateEmail from '../../components/Forms/UpdateEmail';
import { User as UserAPI } from '../../api';
import './SettingsHome.scss';

export const TODO_ICO_PROPS = {
    height: '22px',
    width:  '22px',
    color: 'inherit'
};

export const LANG_LIST = [{
    lang: 'en_us',
    label: 'English (US)',
    enabled: true,
},{
    lang: 'fr_fr',
    label: 'Français',
    enabled: true,
},{
    lang: 'en_us',
    label: 'Español',
    enabled: false,
}];

const Profile = ({
    setUserProfile,
    preferences,
    preferencesAction,
    profile
}) => {
    const navigateManager = useNavigate();
    const [ isLoading, setLoadingStatus ]  = useState(false);
    const [ initialized, setInitialized ] = useState(false);
    const [ mainProfile, setMainProfile ] = useState(null);
    const CheckmarkSymboe = (checked) => (
        checked ?
            <CheckmarkCircle {...TODO_ICO_PROPS} className="icon-color-green" /> :
            <EllipseOutline {...TODO_ICO_PROPS}  className="icon-color-gray"/>
    );
    const langSelected = (preferences || {}).appLang;
    const setAppLangAction = async (lang) => {
        if (!(preferencesAction || {}).setLang) return;
        const setLang = (preferencesAction || {}).setLang;
        UserAnalytic.event({
            category: 'settings_app_global',
            action: 'Select lang',
            label: `Select lang ${lang}`
        });
        setLoadingStatus(true);
        setLang(lang);
        await WaitFor(1500);
        setLoadingStatus(false);
    };
    const langElm = LANG_LIST.find((elm) => elm.lang === langSelected) || {};

    useEffect(() => {
        const init = async () => {
            try {
                if (profile.parentUser) {
                    const profileRes = await UserAPI.getUserInformation(profile.parentUser.userId);
                    setMainProfile(profileRes.data);
                } else {
                    setMainProfile(profile);
                }
                setInitialized(true);
            } catch (err) {
                console.log(err);
            }
        }
        
        if (!initialized) {
            init();
        }
    }, [mainProfile]);

    return (
        <>
            { isLoading ? <Overlay show /> : null }
            <MainLayout pageTitle={languageManager.T('SETTINGS_PAGE_SETTINGS_PROFILE')}>
                <Container className="settings-module">
                    <Row className="mt-4">
                        <Col lg={12}>
                            <Button onClick={() => navigateManager('/settings') }>{languageManager.T('GEN_BACK')}</Button>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col lg={4}>
                            <h3>Your information</h3>
                            <Card className="mb-5 shadow">
                                <Card.Body>
                                    <UserInformation 
                                        currLastname={profile.lastname}
                                        currFirstname={profile.firstname}
                                        setUserProfile={async (profile) => {
                                            setUserProfile(profile);
                                            setMainProfile(profile);
                                        }}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <h3>Email address</h3>
                            <Card className="mb-5 shadow">
                                <Card.Body>
                                    {mainProfile ?
                                        <UpdateEmail
                                            profile={mainProfile}
                                        /> : (
                                            <div>
                                                <p className='fw-bold'>Loading...</p>
                                            </div>
                                        )
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <h3>{languageManager.T('SETTINGS_LABEL_PREFERENCES')}</h3>
                            <Card className="mb-5 shadow">
                                <Card.Body>
                                    <BlockTitle>{languageManager.T('SETTINGS_LABEL_LANGUAGE')}</BlockTitle>
                                    <DropdownButton title={langElm.label || 'loading...'} variant="secondary" size="sm">
                                        {LANG_LIST.map((item, idx) => (
                                            <Dropdown.Item
                                                key={idx}
                                                onClick={() => setAppLangAction(item.lang)}
                                                disabled={item.enabled === false}
                                            >{CheckmarkSymboe(item.enabled && item.lang === langSelected)} {item.label}</Dropdown.Item>
                                        ))}
                                    </DropdownButton>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </MainLayout>
        </>
    );
}

const mapStateToProps = (appState) => ({
    profile: appState.userProfile,
    preferences: appState.preferences
});

const mapDispatchToProps = (dispatch) => ({
    setUserProfile: (userProfile) => dispatch(actionCreator.Profile.setProfile(userProfile)),
    preferencesAction: {
        setLang: (lang) => dispatch(actionCreator.Preferences.setAppLang(lang))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
